<!--
     Copyright (c) 2021-2026 Broadcom. All Rights Reserved.
     Broadcom Confidential. The term "Broadcom" refers to Broadcom Inc.
     and/or its subsidiaries.
-->
<clr-alert [clrAlertType]="'warning'"
           [clrAlertClosable]="false"
           [clrAlertClosed]="!alertText"
           *ngIf="alertText && alertText.length > 0">
    <clr-alert-item>
        <span class="alert-text"
              [innerHTML]="alertText">
        </span>
    </clr-alert-item>
</clr-alert>
<div class="initial {{centered ? 'centered' : ''}}">
    <cds-icon *ngIf="!!iconShape"
              [shape]="iconShape"
              [ngClass]="iconStyle"></cds-icon>
    <h1>{{title}}</h1>
    <p [innerHTML]="description"></p>
    <div class="buttons">
        <ng-container *ngIf="primaryButtonLabel">
            <button class="btn {{primaryButtonStyle}}"
                    id="primaryBtn"
                    (click)="onPrimaryButtonClick()"
                    [disabled]="actionsDisabled"
                    *requiredPrivileges="privileges;requiredRole: role">
                {{primaryButtonLabel}}
                <cds-icon *ngIf="externalLink"
                          shape="pop-out"
                          [attr.title]="'accessibility.new.tab' | vtranslate"></cds-icon>
            </button>
        </ng-container>
        <ng-container *ngIf="secondaryButtonLabel">
            <button class="btn {{secondaryButtonStyle}}"
                    id="secondaryBtn"
                    (click)="onSecondaryButtonClick()"
                    [disabled]="actionsDisabled"
                    *requiredPrivileges="privileges;requiredRole: role">
                {{secondaryButtonLabel}}
                <cds-icon *ngIf="externalLink"
                          shape="pop-out"
                          [attr.title]="'accessibility.new.tab' | vtranslate"></cds-icon>
            </button>
        </ng-container>
    </div>
    <ng-content></ng-content>
</div>
